import styled from 'styled-components';

export const Canvas3d = styled.div`
    position: absolute;
    z-index: 2;
    background-color: transparent;
    top: 0;
    bottom: 0;
    left: 0;
    right: 300px;
`;